import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';

const HistoryService = {
    getUserHistory: async () => {
        try {
            const response = await apiFetch(API_ENDPOINTS.HISTORY, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Greška kod dohvaćanja povijesti posudbi');
            }

            return data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    },

    getHistoryByUserId: async (id) => {
        try {
            const response = await apiFetch(`${API_ENDPOINTS.HISTORY_ID}/${id}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Greška kod dohvaćanja povijesti posudbi');
            }

            return data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    },
};

export default HistoryService;
